import { Outlet } from "react-router-dom";

const EmailsParentPage = () => {
    return <Outlet />;
};

export default EmailsParentPage;
